//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//custom components
import CustomInput from '../../../components/basic/input';
import CustomButton from '../../../components/basic/CustomButton';
import CustomAvatar from '../../../components/basic/customAvatar';
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch';

//material-ui
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, MenuItem, Select, Button, ListItem, CircularProgress, Grid, createMuiTheme, MuiThemeProvider } from '@material-ui/core';

//style
import './ChangePaymentStatus.scss';

//other libraries
import moment from 'moment'

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiFormControl: {
            root: {
                width: "100%",
            }
        },
        MuiFormLabel: {
            root: {
                color: "rgba(0, 0, 0, 0.54) !important"
            }, 
            focused: {
                color: "rgba(0, 0, 0, 0.54) !important"
            }
        },
        MuiInput: {
            underline: {
                "&:after": {
                    borderBottomColor: "rgba(0, 0, 0, 0.54) !important"
                }
            },
            disabled: {
                color: "black",
                "&:before": {
                    borderBottomStyle: 'solid !important',
                    borderBottomColor: "black"
                } 
            }
        }
    }
})


@inject('translate')
@inject('internal')
@observer
export default class ChangePaymentStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            loadingBtn: false,
            // loading: true,
            data: {}
        }
    }

    componentDidMount () {

        this.setState({data: this.props.data}) 
    }

    handleChangeStatus = (val) => {
        let data = this.state.data
        if(val.target.value === null || val.target.value === "null") {
            
            data.paid_at = null
        }
        else {
            data.paid_at = moment()
        }
        this.setState({data: data})
    }

    updateStatus = async() => {
        this.setState({loadingBtn: true})
        let id = this.props.data.id
        let update_data = await api({
            method: 'PATCH',
            url: `customer-orders/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                paid_at: this.state.data.paid_at
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.props.onClose(true)
        }

        this.setState({loadingBtn: false})
    }

    
    render() {
        return (
            <MuiThemeProvider theme={theme}>
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="form-dialog-title"
                classes={{
                    root: "addEditFixedSetDialog-root",
                    paper: "addEditFixedSetDialog-paper"
                }}
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                {this.state.loading 
                ?
                <div style={{minHeight: "100px"}}>
                    <CircularProgress className={'circular-progress'} /> 
                </div> 
                :
                <DialogContent classes={{root: "updateCustomer"}}>
                    <Grid container spacing={8}>
                        
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12} >
                                    <span>Objednávka #{this.state.data.variable_symbol} je</span>
                                    <FormControl className=''>
                                        {/* <InputLabel htmlFor="filterPaymentStatus" >{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].FILTER_BY_PAYMENT}</InputLabel> */}
                                        <Select
                                            value={this.state.data.paid_at === null ? 'null' : 'not null'}
                                            onChange={(val) => this.handleChangeStatus(val)}
                                            inputProps={{
                                                name: 'filterPaymentStatus',
                                                id: 'filterPaymentStatus',
                                            }}
                                        >
                                            <MenuItem value="null" className={'popup-menu'}>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].NOT_PAID}</MenuItem>
                                            <MenuItem value="not null" className={'popup-menu'} >{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].PAID}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                
                                {/* <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_first_name = ref}
                                        text={this.props.translate.i18n.GLOBAL.USER.FIRST_NAME}
                                        value={this.state.data.billing_phone !== null ? this.state.data.billing_first_name : ""}
                                        id={'billing_first_name'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid> */}
                                
                            </Grid>
                        
                        </Grid>
                    </Grid>
                    
                </DialogContent>
                }
                <DialogActions>
                    <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.updateStatus} 
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
            </MuiThemeProvider>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/CustomersOrders/ChangePaymentStatus/ChangePaymentStatus.jsx